import { useQuery } from "@tanstack/react-query";
import { getStudentRatings } from "../query/student-rating";

export const useStudentRatings = (page = 0, size = 20, search?: string) => {
  return useQuery({
    queryKey: ["studentRatings", page, size, search],
    queryFn: () => getStudentRatings(page, size, search),
  });
};
